///
// Module for the Job Vendor Payroll Index view
//
rs.module("content/jobs/vendorpayroll/index",

    ["controls/data/grid"],

    function (gridModule) {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, lrsGridApi, backendUrl) {

            // Unpack js selectors
            var filter = $.js(jsSelectors.filter);

            var batchStatusSelect = filter.js(jsSelectors.batchStatusSelect);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Reload grid data when batch status filter changed
            batchStatusSelect.change(function () {

                loadingSpinner.show();

                gridModule.update(
                    backendUrl,

                    { selectedStatus: this.value },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);